// Copyright (c) 2016 Deere & Company

export default Object.freeze({
    ADD_CLAIM_SPA_ADDITIONAL_REPAIR: 'ADD_CLAIM_SPA_ADDITIONAL_REPAIR',
    ADD_CLAIM_SPA_FILE: 'ADD_CLAIM_SPA_FILE',
    COPY_CLAIM_SPA: 'COPY_CLAIM_SPA',
    CREATE_CLAIM_SPA_LABOR: 'CREATE_CLAIM_SPA_LABOR',
    CREATE_CLAIM_SPA_OTHER_CREDIT: 'CREATE_CLAIM_SPA_OTHER_CREDIT',
    CREATE_CLAIM_SPA_PART: 'CREATE_CLAIM_SPA_PART',
    DELETE_CLAIM_SPA_FILE: 'DELETE_CLAIM_SPA_FILE',
    DELETE_CLAIM_SPA_LABOR: 'DELETE_CLAIM_SPA_LABOR',
    DELETE_CLAIM_SPA_OTHER_CREDIT: 'DELETE_CLAIM_SPA_OTHER_CREDIT',
    DELETE_CLAIM_SPA_PART: 'DELETE_CLAIM_SPA_PART',
    RESET_CLAIM_SPA: 'RESET_CLAIM_SPA',
    RESET_CLAIM_SPA_CONFIRMATION_MODAL: 'RESET_CLAIM_SPA_CONFIRMATION_MODAL',
    RESET_CLAIM_SPA_DETAILS_FOR_UPTIME: 'RESET_CLAIM_SPA_DETAILS_FOR_UPTIME',
    RESET_CLAIM_SPA_FORM_VALIDATION: 'RESET_CLAIM_SPA_FORM_VALIDATION',
    RESET_CLAIM_SPA_PRODUCT_DETAILS: 'RESET_CLAIM_SPA_PRODUCT_DETAILS',
    RESET_CLAIM_SPA_USE_AMOUNT: 'RESET_CLAIM_SPA_USE_AMOUNT',
    REVISE_CLAIM_SPA: 'REVISE_CLAIM_SPA',
    SET_CLAIM_SPA: 'SET_CLAIM_SPA',
    SET_CLAIM_SPA_CONFIRMATION_MODAL: 'SET_CLAIM_SPA_CONFIRMATION_MODAL',
    SET_CLAIM_SPA_CUSTOMER_DETAILS: 'SET_CLAIM_SPA_CUSTOMER_DETAILS',
    SET_CLAIM_SPA_PART_DETAILS: 'SET_CLAIM_SPA_PART_DETAILS',
    SET_CLAIM_SPA_PRODUCT_DETAILS: 'SET_CLAIM_SPA_PRODUCT_DETAILS',
    UPDATE_CLAIM_SPA_BASIS_FOR_SETTLEMENT: 'UPDATE_CLAIM_SPA_BASIS_FOR_SETTLEMENT',
    UPDATE_CLAIM_SPA_CALCULATION_PROPERTY: 'UPDATE_CLAIM_SPA_CALCULATION_PROPERTY',
    UPDATE_CLAIM_SPA_CLAIM_TYPES: 'UPDATE_CLAIM_SPA_CLAIM_TYPES',
    UPDATE_CLAIM_SPA_COMPLAINT_CAUSE: 'UPDATE_CLAIM_SPA_COMPLAINT_CAUSE',
    UPDATE_CLAIM_SPA_COMPLAINT_CORRECTION: 'UPDATE_CLAIM_SPA_COMPLAINT_CORRECTION',
    UPDATE_CLAIM_SPA_CREATE_CLAIM_MODAL_VISIBILITY: 'UPDATE_CLAIM_SPA_CREATE_CLAIM_MODAL_VISIBILITY',
    UPDATE_CLAIM_SPA_DOWN_TIME: 'UPDATE_CLAIM_SPA_DOWN_TIME',
    UPDATE_CLAIM_SPA_DTAC_CASE: 'UPDATE_CLAIM_SPA_DTAC_CASE',
    UPDATE_CLAIM_SPA_DTAC_SOLUTION: 'UPDATE_CLAIM_SPA_DTAC_SOLUTION',
    UPDATE_CLAIM_SPA_FAILED_AREA: 'UPDATE_CLAIM_SPA_FAILED_AREA',
    UPDATE_CLAIM_SPA_FAILED_MODE: 'UPDATE_CLAIM_SPA_FAILED_MODE',
    UPDATE_CLAIM_SPA_FAILED_MODE_COMMENTS: 'UPDATE_CLAIM_SPA_FAILED_MODE_COMMENTS',
    UPDATE_CLAIM_SPA_FAILURE_DATE: 'UPDATE_CLAIM_SPA_FAILURE_DATE',
    UPDATE_CLAIM_SPA_FAILURE_MODE_COLLECTION: 'UPDATE_CLAIM_SPA_FAILURE_MODE_COLLECTION',
    UPDATE_CLAIM_SPA_FAILURE_PART: 'UPDATE_CLAIM_SPA_FAILURE_PART',
    UPDATE_CLAIM_SPA_FILE_LIST: 'UPDATE_CLAIM_SPA_FILE_LIST',
    UPDATE_CLAIM_SPA_FORM_VALIDATION: 'UPDATE_CLAIM_SPA_FORM_VALIDATION',
    UPDATE_CLAIM_SPA_GOODS_INSTALLATION_VAT: 'UPDATE_CLAIM_SPA_GOODS_INSTALLATION_VAT',
    UPDATE_CLAIM_SPA_INSTALLED_BY: 'UPDATE_CLAIM_SPA_INSTALLED_BY',
    UPDATE_CLAIM_SPA_INSTALLED_BY_COLLECTION: 'UPDATE_CLAIM_SPA_INSTALLED_BY_COLLECTION',
    UPDATE_CLAIM_SPA_IS_ACTION_BUTTON_DISABLED: 'UPDATE_CLAIM_SPA_IS_ACTION_BUTTON_DISABLED',
    UPDATE_CLAIM_SPA_IS_COPIED: 'UPDATE_CLAIM_SPA_IS_COPIED',
    UPDATE_CLAIM_SPA_IS_EDITABLE: 'UPDATE_CLAIM_SPA_IS_EDITABLE',
    UPDATE_CLAIM_SPA_IS_VALID_CLAIM: 'UPDATE_CLAIM_SPA_IS_VALID_CLAIM',
    UPDATE_CLAIM_SPA_LABOR_FIELDS: 'UPDATE_CLAIM_SPA_LABOR_FIELDS',
    UPDATE_CLAIM_SPA_LABOR_LOCATION: 'UPDATE_CLAIM_SPA_LABOR_LOCATION',
    UPDATE_CLAIM_SPA_LABOR_TYPE: 'UPDATE_CLAIM_SPA_LABOR_TYPE',
    UPDATE_CLAIM_SPA_MODAL_MODE: 'UPDATE_CLAIM_SPA_MODAL_MODE',
    UPDATE_CLAIM_SPA_OPERATORS_COMMENTS: 'UPDATE_CLAIM_SPA_OPERATORS_COMMENTS',
    UPDATE_CLAIM_SPA_OPERATORS_COMPLAINT: 'UPDATE_CLAIM_SPA_OPERATORS_COMPLAINT',
    UPDATE_CLAIM_SPA_OTHER_CREDIT_AMOUNT: 'UPDATE_CLAIM_SPA_OTHER_CREDIT_AMOUNT',
    UPDATE_CLAIM_SPA_OTHER_CREDIT_COMMENTS: 'UPDATE_CLAIM_SPA_OTHER_CREDIT_COMMENTS',
    UPDATE_CLAIM_SPA_OTHER_CREDIT_DESCRIPTION: 'UPDATE_CLAIM_SPA_OTHER_CREDIT_DESCRIPTION',
    UPDATE_CLAIM_SPA_OTHER_CREDIT_DISTANCE: 'UPDATE_CLAIM_SPA_OTHER_CREDIT_DISTANCE',
    UPDATE_CLAIM_SPA_OWNERSHIP_STATUS: 'UPDATE_CLAIM_SPA_OWNERSHIP_STATUS',
    UPDATE_CLAIM_SPA_PART_FIELDS: 'UPDATE_CLAIM_SPA_PART_FIELDS',
    UPDATE_CLAIM_SPA_PART_SERIAL_NUMBER: 'UPDATE_CLAIM_SPA_PART_SERIAL_NUMBER',
    UPDATE_CLAIM_SPA_PART_UNIT: 'UPDATE_CLAIM_SPA_PART_UNIT',
    UPDATE_CLAIM_SPA_PIN: 'UPDATE_CLAIM_SPA_PIN',
    UPDATE_CLAIM_SPA_PROPERTY: 'UPDATE_CLAIM_SPA_PROPERTY',
    UPDATE_CLAIM_SPA_REPAIR_DATE: 'UPDATE_CLAIM_SPA_REPAIR_DATE',
    UPDATE_CLAIM_SPA_REPAIR_NUMBER: 'UPDATE_CLAIM_SPA_REPAIR_NUMBER',
    UPDATE_CLAIM_SPA_RESPONSIBLE_ACCOUNTS: 'UPDATE_CLAIM_SPA_RESPONSIBLE_ACCOUNTS',
    UPDATE_CLAIM_SPA_STICKY_HEADER_VISIBILITY: 'UPDATE_CLAIM_SPA_STICKY_HEADER_VISIBILITY',
    UPDATE_CLAIM_SPA_TEMPORARY_OBJECT_KEY: 'UPDATE_CLAIM_SPA_TEMPORARY_OBJECT_KEY',
    UPDATE_CLAIM_SPA_TYPE: 'UPDATE_CLAIM_SPA_TYPE',
    UPDATE_CLAIM_SPA_TYPES: 'UPDATE_CLAIM_SPA_TYPES',
    UPDATE_CLAIM_SPA_USE_AMOUNT: 'UPDATE_CLAIM_SPA_USE_AMOUNT',
    UPDATE_CLAIM_SPA_USE_AMOUNT_UNIT: 'UPDATE_CLAIM_SPA_USE_AMOUNT_UNIT',
    UPDATE_CLAIM_SPA_WORK_ORDER_ONE: 'UPDATE_CLAIM_SPA_WORK_ORDER_ONE',
    UPDATE_CLAIM_SPA_WORK_ORDER_TWO: 'UPDATE_CLAIM_SPA_WORK_ORDER_TWO'
});



// WEBPACK FOOTER //
// ./src/claim/spa/action-list.js